module.exports = __webpack_public_path__ + "media/proksee-viewer/images/fb-labels-default-4503c3601cb757e98efff5d4e76158f5.svg";